import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import {
  AddLeave,
  ContentLeave,
  DetailLeave,
  ImportRemainingLeave,
  Leave,
} from "./pages";

const leaveRoutes = [
  {
    path: "/presence/leaves",
    element: (
      <ProtectedRoute name="leaves">
        <Leave />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="leaves"
        defaultTitle="employee.permission_and_leave"
      />
    ),
    children: [
      {
        path: "/presence/leaves/annual-leave",
        element: <ContentLeave key="annual-leave" type="annual-leave" />,
        breadcrumb: null,
        children: [
          {
            path: "/presence/leaves/annual-leave/add",
            element: <AddLeave />,
            breadcrumb: null,
          },
          {
            path: "/presence/leaves/annual-leave/detail/:leaveId",
            element: <DetailLeave />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/presence/leaves/special-leave",
        element: <ContentLeave key="special-leave" type="special-leave" />,
        breadcrumb: null,
        children: [
          {
            path: "/presence/leaves/special-leave/add",
            element: <AddLeave />,
            breadcrumb: null,
          },
          {
            path: "/presence/leaves/special-leave/detail/:leaveId",
            element: <DetailLeave />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/presence/leaves/sick-leave",
        element: <ContentLeave key="sick-leave" type="sick-leave" />,
        breadcrumb: null,
        children: [
          {
            path: "/presence/leaves/sick-leave/add",
            element: <AddLeave />,
            breadcrumb: null,
          },
          {
            path: "/presence/leaves/sick-leave/detail/:leaveId",
            element: <DetailLeave />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/presence/leaves/permission-leave",
        element: (
          <ContentLeave key="permission-leave" type="permission-leave" />
        ),
        breadcrumb: null,
        children: [
          {
            path: "/presence/leaves/permission-leave/add",
            element: <AddLeave />,
            breadcrumb: null,
          },
          {
            path: "/presence/leaves/permission-leave/detail/:leaveId",
            element: <DetailLeave />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/presence/leaves/unpaid-leave",
        element: <ContentLeave key="unpaid-leave" type="unpaid-leave" />,
        breadcrumb: null,
        children: [
          {
            path: "/presence/leaves/unpaid-leave/add",
            element: <AddLeave />,
            breadcrumb: null,
          },
          {
            path: "/presence/leaves/unpaid-leave/detail/:leaveId",
            element: <DetailLeave />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/presence/leaves/annual-leave/remaining-leave",
        element: <ContentLeave key="remaining-leave" type="remaining-leave" />,
        breadcrumb: null,
        children: [
          {
            path: "/presence/leaves/annual-leave/remaining-leave/add",
            element: <AddLeave />,
            breadcrumb: null,
          },
        ],
      },
    ],
  },
  {
    path: "/presence/leaves/annual-leave/remaining-leave/import",
    element: (
      <ProtectedRoute name="leaves_add">
        <ImportRemainingLeave />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="leave.import_remaining_annual_leave" />
    ),
  },
];

export default leaveRoutes;
